export { Badge as default } from './Badge';